import { List } from 'immutable';
import { createSelector, defaultMemoize } from 'reselect';

import { isResourceComplete, isResourceLoading } from './common';

const isTrainingsLoading = defaultMemoize(isResourceLoading);
const getTrainings = defaultMemoize(
    (data) => data.getIn(['trainings'], List()),
);

const getTrainingData = (state) => state.getIn(['app', 'training']);
const isTrainingLoaded = createSelector(getTrainingData, isResourceComplete);
const getTrainingTitle = createSelector(getTrainingData, (data) => data.getIn(['training', 'title']));

export {
    isTrainingLoaded,
    isTrainingsLoading,
    getTrainings,
    getTrainingTitle,
};
